/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Team_Share_Event_CountInputs */



/**
* | output |
* | --- |
* | "{count} events" |
*
* @param {Team_Share_Event_CountInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_share_event_count = /** @type {((inputs: Team_Share_Event_CountInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Share_Event_CountInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`${i?.count} events`)
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.count} events`)
	if (locale === "it") return /** @type {LocalizedString} */ (`${i?.count} events`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`${i?.count} events`)
	if (locale === "es") return /** @type {LocalizedString} */ (`${i?.count} events`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`${i?.count} events`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`${i?.count} events`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`${i?.count} events`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`${i?.count} events`)
	return /** @type {LocalizedString} */ (`${i?.count} events`)
});